import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { LOGISTICA_PRODUCTOS_CON_LOTE, VALIDAR_STOCK } from '../../../../common/types/parametroType'
import global from '../../../../common/utility/global';
import auth from '../../../../common/utility/auth';

export default function Productos(props) {
    const mostrarLote = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Tipo de Comprobante',
                        dataIndex: 'tipoComprobante',
                        key: 'tipoComprobante',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },
                    {
                        title: 'Comprobante',
                        dataIndex: 'documentoSerie',
                        key: 'documentoSerie',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },

                    {
                        title: 'Fecha Emisión',
                        dataIndex: 'fechaEmision',
                        key: 'fechaEmision',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },
                    {
                        title: 'Importe Comprobante',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },
                    {
                        title: 'Cuota',
                        dataIndex: 'cuota',
                        key: 'cuota',
                        align: 'center',
                        width: 65,
                        ellipsis: true
                    },

                    {
                        title: 'Moneda',
                        dataIndex: 'idMoneda',
                        key: 'idMoneda',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{value == 1 ? 'PEN' : 'USD'}</span>
                        )
                    },

                    {
                        title: 'Importe Retención S/',
                        dataIndex: 'totalRetencion',
                        key: 'totalRetencion',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },

                    {
                        title: 'Importe Pagado S/',
                        dataIndex: 'totalPagado',
                        key: 'totalPagado',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <span>{parseFloat(value).toFixed(2)}</span>

                        )
                    },

                ]}
            />
        </div>
    );
}